import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Change } from "../../../global/interfaces/Change";
import { links } from "../../../utils/links";
import {
  Link,
  Toast,
  ToastBody,
  ToastFooter,
  ToastTitle,
  useId,
  useToastController,
} from "@fluentui/react-components";
import ChangesLoadedToast from "../Toasts/ChangesLoadedToast";

const useGetAllChangesForAdmin = () => {
  const local_jwt = localStorage.getItem("jwt");
  const headers = { Authorization: `Bearer ${local_jwt}` };

  const toasterId = useId("admin-toaster");
  const { dispatchToast } = useToastController(toasterId);

  const notify = () =>
    dispatchToast(
      <Toast>
        <ToastTitle action={<Link>Undo</Link>}>Email sent</ToastTitle>
        <ToastBody subtitle="Subtitle">This is a toast body</ToastBody>
        <ToastFooter>
          <Link>Action</Link>
          <Link>Action</Link>
        </ToastFooter>
      </Toast>,
      { intent: "success" }
    );

  return useQuery({
    queryKey: ["Changes"],
    queryFn: () =>
      axios.get<Change[]>(links.getAllAenderungen, { headers }).then((res) => {
        notify();
        return res.data;
      }),
  });
};

export default useGetAllChangesForAdmin;
